import { store } from '../../../store/store'
import util from '@/util'

export default {
  connectUser
}

function connectUser (state) {
  const { currentBrandId, agentId, telNumber, name } = store.getters
  const connectMsg = {
    'brandId': currentBrandId || util.parseLoginToken().agentMappingBrandViews[0].brandId,
    'agentId': agentId,
    'agentName': name,
    'extension': telNumber,
    'sendType': 'regi',
    'data': {
      'viewType': 'call',
      'availRecv': []
    }
  }
  store.commit('sendMessageToStatusSocket', JSON.stringify(connectMsg))
}



// WEBPACK FOOTER //
// ./src/util/call/klCnsAPI/statusEvent.js